import { SelectOption } from "atoms/forms/select";
import UserCollectionShareType, {
    UserCollectionShareTypeValueToNameMap,
} from "models/enumerations/user-collection-share-type";
import SelectFormField from "molecules/form-fields/select-form-field";
import React from "react";
import RoleType from "utilities/enumerations/role-type";
import useCurrentIdentity from "utilities/hooks/use-current-identity";
import { t } from "utilities/localization-utils";
import StringUtils from "utilities/string-utils";

interface FilterByCollectionShareTypeProps {
    collectionShareType?: UserCollectionShareType;
    onChange: (option: SelectOption | undefined) => void;
}

const FilterByCollectionShareType = ({
    collectionShareType,
    onChange,
}: FilterByCollectionShareTypeProps) => {
    const { currentIdentity } = useCurrentIdentity();
    const isMemberOfTeam = currentIdentity?.isGroupMember();
    const allowedToUseWorkGroups = currentIdentity?.isCurrentRole(
        RoleType.ENTERPRISE
    );
    const options: SelectOption[] = [
        {
            data: null,
            value: "",
            label: StringUtils.capitalize(t("all")),
        },
        {
            data: UserCollectionShareType.User,
            value: UserCollectionShareType.User.toString(),
            label: t(
                UserCollectionShareTypeValueToNameMap[
                    UserCollectionShareType.User
                ]
            ),
        },
        ...[
            ...(allowedToUseWorkGroups
                ? [
                      {
                          data: UserCollectionShareType.WorkGroup,
                          value: UserCollectionShareType.WorkGroup.toString(),
                          label: t(
                              UserCollectionShareTypeValueToNameMap[
                                  UserCollectionShareType.WorkGroup
                              ]
                          ),
                      },
                  ]
                : []),
        ],
        {
            data: UserCollectionShareType.Team,
            value: UserCollectionShareType.Team.toString(),
            label: t(
                UserCollectionShareTypeValueToNameMap[
                    UserCollectionShareType.Team
                ]
            ),
        },
    ];

    const handleOnChange = (newVal: SelectOption | undefined) => {
        onChange(newVal?.data);
    };

    return (
        <>
            {isMemberOfTeam && (
                <SelectFormField
                    ariaLabelOnly
                    label={t("filterBy", { item: "" })}
                    value={collectionShareType?.toString()}
                    onChange={handleOnChange}
                    options={options}
                />
            )}
        </>
    );
};

export default FilterByCollectionShareType;
